import * as z from "zod";

import { departureResponse } from "../types/departure";
import { stationsSchema } from "../types/station";
const SL_API_URL = "https://transport.integration.sl.se/v1";

export async function getDepartures({ station }: { station: number }) {
  const response = await fetch(
    `${SL_API_URL}/sites/${station}/departures?cacheBuster=${Date.now()}`,
  );
  const data = (await response.json()) as unknown;
  const departures = departureResponse.parse(data).departures;

  if (!departures) {
    return {
      departures: [],
      stopDeviations: departureResponse.parse(data).stop_deviations,
    };
  }
  return {
    departures: departures.filter(
      ({ expected, scheduled }) =>
        (expected && expected > new Date()) || scheduled > new Date(),
    ),
    stopDeviations: departureResponse.parse(data).stop_deviations,
  };
}

const cacheStationSchema = z.object({
  stations: stationsSchema,
  timestamp: z.number(),
});

export async function getStations() {
  const cachedStationsString = localStorage.getItem("stations");
  if (cachedStationsString) {
    const cachedStations = cacheStationSchema.parse(
      JSON.parse(cachedStationsString),
    );
    if (cachedStations.timestamp > Date.now() - 1000 * 60 * 60 * 24) {
      return cachedStations.stations;
    }
  }

  const response = await fetch(`${SL_API_URL}/sites?expand=false`);
  const data = (await response.json()) as unknown;

  const stations = stationsSchema.parse(data);
  localStorage.setItem(
    "stations",
    JSON.stringify({ stations, timestamp: Date.now() }),
  );

  return stations;
}
